import { render, staticRenderFns } from "./nindex.vue?vue&type=template&id=6121d381&scoped=true&"
import script from "./nindex.vue?vue&type=script&lang=js&"
export * from "./nindex.vue?vue&type=script&lang=js&"
import style0 from "./nindex.vue?vue&type=style&index=0&id=6121d381&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6121d381",
  null
  
)

export default component.exports